import React from 'react';
import { motion } from 'framer-motion';
import styles from './Card.module.css';

/**
 * Card   the atomic container used across all pages.
 * variant: 'default' | 'dark' | 'gradient' | 'cyan' | 'glass' | 'soft'
 * padding: 'sm' | 'md' | 'lg'
 * hover:   enable subtle lift on hover
 */
const Card = ({
  children,
  variant = 'default',
  padding = 'md',
  hover = true,
  className = '',
  onClick,
  as: Component = 'div',
  ...rest
}) => {
  const classes = [
    styles.card,
    styles[variant],
    styles[`pad_${padding}`],
    hover ? styles.hoverable : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const MotionComponent = motion(Component);

  return (
    <MotionComponent
      className={classes}
      onClick={onClick}
      whileHover={hover ? { y: -4 } : undefined}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      {...rest}
    >
      {children}
    </MotionComponent>
  );
};

export default Card;
